var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings-workflow-history" },
    [
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "content-item" },
          [
            _c(
              "feature-flag",
              { attrs: { name: "workflowGraph" } },
              [
                _c("settings-toggle", {
                  attrs: {
                    label: "Enable history graph",
                    name: "graphEnabled",
                    value: _vm.graphEnabled
                  },
                  on: { change: _vm.onChange }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-item" },
          [
            _c("settings-toggle", {
              attrs: {
                label: "Enable history event param highlighting",
                name: "workflowHistoryEventHighlightListEnabled",
                value: _vm.modalWorkflowHistoryEventHighlightListEnabled
              },
              on: {
                change: _vm.onWorkflowHistoryEventHighlightListEnabledChange
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "history-event-param-content",
            class: {
              disabled: !_vm.modalWorkflowHistoryEventHighlightListEnabled
            }
          },
          [
            _c(
              "div",
              { staticClass: "content-item" },
              [
                _c(
                  "flex-grid",
                  { attrs: { "align-items": "center" } },
                  [
                    _c("flex-grid-item", { attrs: { grow: "1" } }, [
                      _c("h4", [_vm._v("History event params")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "flex-grid-item",
                      [
                        _c("button-fill", {
                          attrs: {
                            disabled: !_vm.modalWorkflowHistoryEventHighlightListEnabled,
                            label: "NEW"
                          },
                          on: {
                            click: _vm.onWorkflowHistoryEventHighlightListAdd
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "scrollable" },
              _vm._l(_vm.modalWorkflowHistoryEventHighlightList, function(
                event
              ) {
                return _c(
                  "div",
                  { key: event.id, staticClass: "content-item" },
                  [
                    _c(
                      "flex-grid",
                      { attrs: { "align-items": "center" } },
                      [
                        _c(
                          "flex-grid-item",
                          { attrs: { grow: "1" } },
                          [
                            _c(
                              "flex-grid",
                              { attrs: { "align-items": "center" } },
                              [
                                _c(
                                  "flex-grid-item",
                                  { attrs: { grow: "1", width: "345px" } },
                                  [
                                    _c("select-input", {
                                      attrs: {
                                        disabled:
                                          !_vm.modalWorkflowHistoryEventHighlightListEnabled ||
                                          !event.isEnabled,
                                        label: "Event type",
                                        name: "eventType",
                                        options: _vm.workflowEventTypes,
                                        value: event.eventType
                                      },
                                      on: {
                                        change: function(value) {
                                          return _vm.onWorkflowHistoryEventHighlightListChange(
                                            {
                                              event: event,
                                              key: "eventType",
                                              value: value
                                            }
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "flex-grid-item",
                                  [
                                    _c("text-input", {
                                      attrs: {
                                        label: "Event param name",
                                        disabled:
                                          !_vm.modalWorkflowHistoryEventHighlightListEnabled ||
                                          !event.isEnabled,
                                        value: event.eventParamName
                                      },
                                      on: {
                                        input: function(ref) {
                                          var value = ref.target.value

                                          return _vm.onWorkflowHistoryEventHighlightListChange(
                                            {
                                              event: event,
                                              key: "eventParamName",
                                              value: value
                                            }
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "flex-grid-item",
                          [
                            _c("toggle-button", {
                              attrs: {
                                disabled: !_vm.modalWorkflowHistoryEventHighlightListEnabled,
                                labels: true,
                                value: event.isEnabled
                              },
                              on: {
                                change: function(ref) {
                                  var value = ref.value

                                  return _vm.onWorkflowHistoryEventHighlightListChange(
                                    {
                                      event: event,
                                      key: "isEnabled",
                                      value: value
                                    }
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "flex-grid-item",
                          [
                            _c("button-icon", {
                              attrs: {
                                disabled: !_vm.modalWorkflowHistoryEventHighlightListEnabled,
                                icon: "icon_trash",
                                size: "20px"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onWorkflowHistoryEventHighlightListRemove(
                                    event
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("settings-footer", {
        attrs: {
          "submit-enabled": _vm.isSubmitEnabled || _vm.isSettingsChanged
        },
        on: { cancel: _vm.onClose, submit: _vm.onSubmit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff2b2a72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff2b2a72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/settings-workflow-history/component.vue
// module id = 1563
// module chunks = 0